module.exports = __webpack_public_path__ + "static/media/table-icon.ef0e83a6.svg";